export function CompanyListSkeleton() {
  return (
    <div className="container mx-auto animate-pulse p-6">
      {/* Header */}
      <div className="mb-6 flex items-center justify-between">
        <div className="flex items-center gap-3">
          <div className="bg-muted h-6 w-32 rounded" />
          <div className="bg-muted h-5 w-40 rounded" />
          <div className="bg-muted h-5 w-20 rounded" />
        </div>
        <div className="bg-muted h-8 w-32 rounded" />
      </div>

      {/* Stats cards */}
      <div className="mb-6 grid grid-cols-2 gap-3 sm:grid-cols-4">
        {Array.from({ length: 4 }).map((_, i) => (
          <div key={i} className="bg-muted h-16 rounded-lg border" />
        ))}
      </div>

      {/* Filter bar */}
      <div className="bg-card mb-6 rounded-lg border p-4">
        <div className="flex flex-wrap gap-4">
          <div className="bg-muted h-8 min-w-[300px] flex-1 rounded" />
          <div className="flex gap-2">
            {Array.from({ length: 4 }).map((_, i) => (
              <div key={i} className="bg-muted h-8 w-20 rounded-full" />
            ))}
          </div>
        </div>
      </div>

      {/* Table */}
      <div className="bg-card overflow-hidden rounded-lg border">
        <div className="bg-muted/50 border-b px-4 py-3">
          <div className="flex gap-8">
            {[32, 24, 20, 12, 12, 16, 20, 16, 20].map((w, i) => (
              <div key={i} className={`h-3 w-${String(w)} bg-muted rounded`} />
            ))}
          </div>
        </div>
        {Array.from({ length: 8 }).map((_, i) => (
          <div key={i} className="flex items-center gap-8 border-b px-4 py-3">
            <div className="w-32 space-y-1.5">
              <div className="bg-muted h-3 w-28 rounded" />
              <div className="bg-muted h-2.5 w-24 rounded" />
            </div>
            <div className="bg-muted h-3 w-24 rounded font-mono" />
            <div className="bg-muted h-3 w-20 rounded" />
            <div className="bg-muted h-5 w-12 rounded" />
            <div className="bg-muted h-3 w-10 rounded" />
            <div className="bg-muted h-5 w-16 rounded-full" />
            <div className="bg-muted h-3 w-20 rounded" />
            <div className="bg-muted h-3 w-16 rounded" />
            <div className="bg-muted h-7 w-20 rounded" />
          </div>
        ))}
      </div>
    </div>
  )
}
